import { createUseStyles } from 'react-jss';

const styles = createUseStyles(() => {
  return {
    // TODO: temporary fix for <Card/> using `href` params, as `wds-react` css is interfering with the Card component's styling
    appGrid: {
      '& a': {
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'none',
        },
      },
    },
  };
});

export default styles;
